module.exports = __webpack_public_path__ + "img/FAQ.2e85d507.png";